export default {
  allMaintenanceSchedulings: [],
  maintenanceScheduling: {},
}
